import { render, staticRenderFns } from "./WsInfoColor.vue?vue&type=template&id=78066c23&"
import script from "./WsInfoColor.vue?vue&type=script&lang=js&"
export * from "./WsInfoColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports